/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Brand_TaglineInputs */

const en_footer_brand_tagline = /** @type {(inputs: Footer_Brand_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The AI-powered marketplace for creators to sell anything with their own branded storefront.`)
};

const es_footer_brand_tagline = /** @type {(inputs: Footer_Brand_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El mercado impulsado por IA para que los creadores vendan cualquier cosa con su propia tienda de marca.`)
};

const fr_footer_brand_tagline = /** @type {(inputs: Footer_Brand_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La marketplace propulsée par l'IA pour que les créateurs puissent tout vendre avec leur propre vitrine de marque.`)
};

const de_footer_brand_tagline = /** @type {(inputs: Footer_Brand_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der KI-gestützte Marktplatz für Creator, um alles mit einer eigenen Marken-Storefront zu verkaufen.`)
};

const ja_footer_brand_tagline = /** @type {(inputs: Footer_Brand_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリエイターが自分自身のブランドストアフロントであらゆるものを販売できるAI搭載のマーケットプレイス。`)
};

const zh_footer_brand_tagline = /** @type {(inputs: Footer_Brand_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 驱动的创作者市场，使用您专属的品牌店铺销售任何东西。`)
};

const ar_footer_brand_tagline = /** @type {(inputs: Footer_Brand_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السوق المدعوم بالذكاء الاصطناعي للمبدعين لبيع أي شيء بواجهة متجر خاصة بعلامتهم التجارية.`)
};

const id_footer_brand_tagline = /** @type {(inputs: Footer_Brand_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marketplace berbasis AI untuk para kreator menjual apa pun dengan etalase bermerek mereka sendiri.`)
};

const it_footer_brand_tagline = /** @type {(inputs: Footer_Brand_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il marketplace basato sull'IA per i creatori che vogliono vendere qualsiasi cosa con la propria vetrina di marca.`)
};

const ru_footer_brand_tagline = /** @type {(inputs: Footer_Brand_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Маркетплейс на базе ИИ для авторов — продавайте что угодно с помощью собственной брендированной витрины.`)
};

const pt_footer_brand_tagline = /** @type {(inputs: Footer_Brand_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O marketplace com tecnologia de IA para criadores venderem qualquer coisa com sua própria vitrine.`)
};

const ko_footer_brand_tagline = /** @type {(inputs: Footer_Brand_TaglineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`크리에이터가 자신만의 브랜드 스토어로 무엇이든 판매할 수 있는 AI 기반 마켓플레이스.`)
};

/**
* | output |
* | --- |
* | "The AI-powered marketplace for creators to sell anything with their own branded storefront." |
*
* @param {Footer_Brand_TaglineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const footer_brand_tagline = /** @type {((inputs?: Footer_Brand_TaglineInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Brand_TaglineInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_footer_brand_tagline(inputs)
	if (locale === "es") return es_footer_brand_tagline(inputs)
	if (locale === "fr") return fr_footer_brand_tagline(inputs)
	if (locale === "de") return de_footer_brand_tagline(inputs)
	if (locale === "ja") return ja_footer_brand_tagline(inputs)
	if (locale === "zh") return zh_footer_brand_tagline(inputs)
	if (locale === "ar") return ar_footer_brand_tagline(inputs)
	if (locale === "id") return id_footer_brand_tagline(inputs)
	if (locale === "it") return it_footer_brand_tagline(inputs)
	if (locale === "ru") return ru_footer_brand_tagline(inputs)
	if (locale === "pt") return pt_footer_brand_tagline(inputs)
	return ko_footer_brand_tagline(inputs)
});